import { render, staticRenderFns } from "./practice.vue?vue&type=template&id=2f1f62bd&scoped=true"
import script from "./practice.vue?vue&type=script&lang=js"
export * from "./practice.vue?vue&type=script&lang=js"
import style0 from "./practice.vue?vue&type=style&index=0&id=2f1f62bd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1f62bd",
  null
  
)

export default component.exports